module.exports = __webpack_public_path__ + "static/media/orange_nebula_RT.ec3dfc06.png";